/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpGold.vue?vue&type=template&id=fa16410c&scoped=true"
import script from "./popUpGold.vue?vue&type=script&lang=js"
export * from "./popUpGold.vue?vue&type=script&lang=js"
import style0 from "./popUpGold.vue?vue&type=style&index=0&id=fa16410c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa16410c",
  null
  
)

export default component.exports